import type { TopOfMindStatus } from '@wundo/shared/topOfMind.ts';

/** Whose summary the panel shows; the tooltip names it. */
export type TopOfMindHolderKind = 'track' | 'cohort';

export interface TopOfMindPanelLabels {
  title: string;
  /** Behind the info icon beside the title: what the summary is used for. */
  info: (params: { holder: TopOfMindHolderKind }) => string;
  status: Record<Exclude<TopOfMindStatus, 'none'>, string>;
  /** Nothing was ever scheduled: no documents linked yet. */
  noneNote: string;
  scheduledNote: string;
  generatingNote: string;
  failedNote: string;
  waitingForDocuments: (params: { count: number }) => string;
  generatedAt: (params: { date: string }) => string;
  rebuild: string;
}

export const DEFAULT_TOP_OF_MIND_PANEL_LABELS: TopOfMindPanelLabels = {
  title: 'Summary',
  info: ({ holder }) =>
    `Wundo keeps this summary in mind whenever it coaches someone in this ${holder}: in chat, meeting prep, meeting feedback and practice debriefs.`,
  status: {
    scheduled: 'Scheduled',
    generating: 'Generating',
    ready: 'Ready',
    failed: 'Failed',
  },
  noneNote: 'No summary yet. Link documents to build one.',
  scheduledNote: 'A new summary will be written shortly.',
  generatingNote: 'The summary is being written.',
  failedNote: 'The last attempt to write the summary failed.',
  waitingForDocuments: ({ count }) =>
    count === 1
      ? 'Waiting for 1 document to finish processing.'
      : `Waiting for ${count} documents to finish processing.`,
  generatedAt: ({ date }) => `Generated ${date}`,
  rebuild: 'Rebuild now',
};
